import * as React from "react";
import { Redirect } from "react-router-dom";
import Loader from "react-loader";

import withServices from "../../../HOCs/withServices";
import Navbar from "../../../components/CustomNav/CustomNav.Component";
import CourseInfo from "../../../components/DataCentre/CourseInfo";
import ComparisonLists from "../../../components/DataCentre/ComparisonLists";
import PerformanceGraph from "../../../components/DataCentre/PerformanceGraph";
import StudentsPerformance from "../../../components/DataCentre/StudentsPerformance";
import { toast } from "react-toastify";

import {
  Wrapper,
  Content,
  ContentRow,
  ContentCol,
  LessonSelector,
  PickerHeader,
} from "./CourseDetails.styles";
import { HeaderRow } from "../DataCentre.styles";
import DatePicker from "../../../components/DatePicker/DatePickerComponent";

interface IProps {
  services?: any;
  location?: any;
  match?: any;
  history?: any;
  isParent?: boolean;
  isTeacher?: boolean;
  isSchool?: boolean;
}

interface IState {
  toLogin: boolean;
  loaded: boolean;
  isLoading: boolean;
  data: any;
  selectedLesson: string;
  startDateObj?: unknown;
  endDateObj?: unknown;
  startDate: string;
  endDate: string;
  lessonDetails: any;
}

class CourseDetails extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      toLogin: false,
      loaded: false,
      isLoading: false,
      data: {},
      selectedLesson: "",
      startDate: "",
      endDate: "",
      startDateObj: null,
      endDateObj: null,
      lessonDetails: null,
    };

    this.onLogout = this.onLogout.bind(this);
    this.onGoBack = this.onGoBack.bind(this);
    this.getCourseDetails = this.getCourseDetails.bind(this);
  }

  public async componentDidMount() {
    const {
      match,
      history,
      isParent,
      isSchool,
      isTeacher,
      services: { isUserLoggedIn, institutionsAPI, currentUserID, parentsAPI },
    } = this.props;

    if (!isUserLoggedIn) {
      this.setState({ toLogin: true });
      return;
    }

    const {
      params: { id: courseID },
    } = match;

    this.setState({ loaded: false });

    if (isParent) {
      const res = await parentsAPI.getCourseDetails({
        courseID,
        parentID: currentUserID,
      });

      if (res.ok) {
        this.setState({ data: res.data, loaded: true });
      } else {
        alert("Error fetching parents's details!");
      }
    }

    // if (isSchool) {
    //   const res = await institutionsAPI.getCourseDetails({
    //     courseID,
    //     institutionID: currentUserID,
    //   });

    //   if (res.ok) {
    //     this.setState({ data: res.data, loaded: true });
    //   } else {
    //     alert("Error fetching school's details!");
    //   }
    // }

    if (isTeacher || isSchool) {
      const {
        location: { state },
      } = this.props.history;

      const { startDateObj, endDateObj } = state;

      if (
        typeof startDateObj === "undefined" &&
        typeof endDateObj === "undefined"
      ) {
        toast.warn("Please select a date range to start");
        return;
      }

      const startDate = `${startDateObj.year}-${startDateObj.month}-${startDateObj.day}`;

      const endDate = `${endDateObj.year}-${endDateObj.month}-${endDateObj.day}`;

      this.setState(
        {
          startDateObj: { ...startDateObj },
          endDateObj: { ...endDateObj },
          startDate,
          endDate,
        },
        () => {
          this.getCourseDetails();
        }
      );
    }
  }

  public onLogout() {
    this.setState({ toLogin: true });
  }

  public onGoBack() {
    const { history } = this.props;

    history.goBack();
  }

  public onStartDateChange = (dateObj) => {
    const date = `${dateObj.year}-${dateObj.month}-${dateObj.day}`;
    this.setState({ startDateObj: dateObj, startDate: date });
  };

  public onEndDateChange = (dateObj) => {
    const date = `${dateObj.year}-${dateObj.month}-${dateObj.day}`;
    this.setState({ endDateObj: dateObj, endDate: date });
  };

  public async getCourseDetails() {
    const { startDate, endDate } = this.state;
    this.setState({ isLoading: true });
    const {
      isTeacher,
      isSchool,
      services: { teachersAPI, institutionsAPI },
      match,
    } = this.props;
    const {
      params: { id: courseID },
    } = match;

    if (!startDate.length || !endDate.length) {
      toast.warn("Please make sure you have picked the correct date ranges");
      return;
    }

    const api = isTeacher ? teachersAPI : institutionsAPI;

    const [learnersRes, courseRes] = await Promise.all([
      api.getCourseEnrolledLearners(courseID, startDate, endDate),
      api.getSingleCourseSummary(courseID, startDate, endDate),
    ]);

    console.log({ courseRes });

    this.setState({
      data: {
        learners: learnersRes.data.enrolled_learners,
        ...courseRes.data.course_summary,
      },
      loaded: true,
      isLoading: false,
    });
  }

  public onSelectLesson = (e) => {
    const selectedLesson = e.target.value;
    // const {startDate, endDate} = this.state;

    this.setState({ selectedLesson });

    if (this.props.isTeacher || this.props.isSchool) {
      this.fetchLessonDetails(selectedLesson);
    }
  };

  public async fetchLessonDetails(lessonId) {
    const {
      startDate,
      endDate,
      data: { lessons },
    } = this.state;
    const {
      services: { teachersAPI, institutionsAPI }, isTeacher,
      match,
    } = this.props;
    const {
      params: { id: courseId },
    } = match;
    const api = isTeacher ? teachersAPI : institutionsAPI;

    this.setState({ loaded: false, isLoading: true });

    const [lessonRes, learnersRes] = await Promise.all([
      api.getLessonSummary(
        courseId,
        lessons[lessonId].lessonid,
        startDate,
        endDate
      ),
      api.getLessonLearners(
        courseId,
        lessons[lessonId].lessonid,
        startDate,
        endDate
      ),
    ]);

    this.setState({
      lessonDetails: { ...learnersRes.data, ...lessonRes.data.lesson_summary },
      loaded: true,
      isLoading: false,
    });
  }

  public renderGeneralLessonPicker() {
    const { selectedLesson, data } = this.state;
    if (data.lessons.length) {
      return (
        <select
          className="custom-select"
          value={selectedLesson}
          onChange={this.onSelectLesson}
        >
          <option value="">--</option>
          {data.Lessons.map((lesson: any, index: number) => {
            return (
              <option key={lesson.id} value={index}>
                {lesson.LessonIdentifier}
              </option>
            );
          })}
        </select>
      );
    } else {
      return (
        <PickerHeader>
          This course has no completed lessons at this time.
        </PickerHeader>
      );
    }
  }

  public renderTeacherLessonPicker() {
    const { selectedLesson, data } = this.state;
    if (data.lessons.length) {
      return (
        <select
          className="custom-select"
          value={selectedLesson}
          onChange={this.onSelectLesson}
        >
          <option value="">--</option>
          {data.lessons.map((lesson: any, index: number) => {
            return (
              <option key={lesson.lessonid} value={index}>
                {lesson.lesson_display_name === "default"
                  ? lesson.lesson_name
                  : lesson.lesson_display_name}
              </option>
            );
          })}
        </select>
      );
    } else {
      return (
        <PickerHeader>
          This course has no completed lessons at this time.
        </PickerHeader>
      );
    }
  }

  public render() {
    const { data, selectedLesson, lessonDetails, loaded, isLoading } =
      this.state;
    const { isTeacher, isSchool } = this.props;

    if (this.state.toLogin) {
      return <Redirect to="/login" />;
    }

    // if (Object.keys(data).length === 0) {
    //   return <Loader color="#acff24" />;
    // }

    return (
      <Wrapper>
        <Navbar logoutParent={this.onLogout} />
        <Content>
          <ContentRow className="single-col">
            <p className="go-back" onClick={this.onGoBack}>
              &lt; Back
            </p>
          </ContentRow>

          {isTeacher || isSchool ? (
            <React.Fragment>
              <PickerHeader>
                Please select a time period you would like to explore
              </PickerHeader>
              <HeaderRow>
                <DatePicker
                  value={this.state.startDateObj}
                  onChange={this.onStartDateChange}
                  placeholder="Pick a start date"
                />
                <DatePicker
                  value={this.state.endDateObj}
                  onChange={this.onEndDateChange}
                  placeholder="Pick an end date"
                />
                <button
                  onClick={this.getCourseDetails}
                  className="button green-button go-action"
                >
                  GO
                </button>
              </HeaderRow>
            </React.Fragment>
          ) : (
            ""
          )}
        </Content>

        {loaded && data.lessons.length ?  (
          <Content>
            <ContentRow>
              <ContentCol>
                <CourseInfo data={data} isSchool={isSchool} isTeacher={isTeacher} />
                {selectedLesson ? (
                  <>
                    <ComparisonLists
                      data={isTeacher || isSchool ? lessonDetails : data}
                      selectedLesson={selectedLesson}
                      isTeacher={isTeacher}
                    />
                    <ComparisonLists
                      data={isTeacher || isSchool ? lessonDetails : data}
                      selectedLesson={selectedLesson}
                      type="rank"
                      isTeacher={isTeacher}
                    />
                  </>
                ) : (
                  ""
                )}
              </ContentCol>
              <ContentCol>
                <PerformanceGraph
                  data={data}
                  isCourseDetails={true}
                  isTeacher={isTeacher}
                  isSchool={isSchool}
                />
                <LessonSelector>
                  <p>See how your learners performed in:</p>
                  {isTeacher || isSchool
                    ? this.renderTeacherLessonPicker()
                    : this.renderGeneralLessonPicker()}
                </LessonSelector>
              </ContentCol>
            </ContentRow>

            <ContentRow className="single-col">
              <ContentCol>
                {((isTeacher || isSchool) && lessonDetails != null) ||
                (!isTeacher && !isSchool && selectedLesson) ? (
                  <StudentsPerformance
                    data={(isTeacher || isSchool) ? lessonDetails : data}
                    isLesson={true}
                      isTeacher={isTeacher}
                      isSchool={isSchool}
                    selectedLesson={selectedLesson}
                  />
                ) : (
                  ""
                )}
              </ContentCol>
            </ContentRow>
          </Content>
        ) : (
            <PickerHeader style={{color: "var(--red)"}}>There are no lessons in this course yet!</PickerHeader>
        )}

        {isLoading ? <Loader color="#acff24" /> : ""}
      </Wrapper>
    );
  }
}

export default withServices(CourseDetails);



// WEBPACK FOOTER //
// ./src/pages/DataCenter/CourseDetails/CourseDetails.tsx